import * as fromDatatype from "../../../../models/datatype-library";
export class TransitionGenerateDto {
    process_guid: fromDatatype.GuidDataFieldInterface;
    role_guids: any [];
  }
